import React, {createRef, useEffect, useState} from 'react';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import {VisitorInfo} from "../../interface/model/visitor";
import useHover from "../hover";

interface ManagementMenuOptionItem {
    innerHTML:string,
    onClickHandler: () => (e: React.MouseEvent) => void;
}
interface ManagementMenuOption {
    items:Array<ManagementMenuOptionItem>
}

export function ManagementMenuOptionItem({items}:ManagementMenuOption) {
    const [ openFlag, setOpenFlag ] = useState<boolean>(false);
    const handlerClose = (handler) => {
        setOpenFlag(false);
        try {
            handler()
        } catch (err) {

        }
    }

    const handlerOpen = (handler) => {
        setOpenFlag(true);
    }

    return (
        <>
            <div style={{position:'relative'}}>
                <button className="menu_btn_box" onClick={handlerOpen}>
                    <svg className="menu_open_dot" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
                    </svg>
                </button>
            </div>
            {
                openFlag &&
                <OpenBtnBox
                    ManagementMenuOption={items}
                    handlerClose={handlerClose} />
            }
        </>
    )
}

function OpenBtnBox({ ManagementMenuOption, handlerClose }) {
    const hamburgerRef = createRef<any>();

    const handleClickOutside = event => {
        console.log("event target is: ", event.target);
        if (!hamburgerRef.current.contains(event.target)) { // 3. outside click 인지 판단
            handlerClose();
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);

        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [])

    return (
        <>
            <div className="openSelectBox" ref={hamburgerRef}>
                <ul >
                    {
                        ManagementMenuOption.map((row, index) => (
                            <li key={`menuOptionItemsKey-${index}`}
                                onClick={() => handlerClose(row.onClickHandler)}>{row.innerHTML}</li>
                        ))
                    }
                    <li onClick={handlerClose}>닫기</li>
                </ul>
            </div>
        </>
    )
}

export function ManagementMenuOptionItem2({items}:ManagementMenuOption) {

    const [ loading, setLoading ] = useState<boolean>(false);

    const handlerClose = (handler) => {
        if(loading) {
            alert('처리중입니다. 잠시만 기다려주세요.');
        } else {
            try {
                setLoading(true);
                handler();
            } catch(err) {console.log(err)}
        }
    }

    useEffect(() => {
        if(loading) {
            const countCheck = setInterval(() => {
                    setLoading(false);
                },
                3000
            );
            return () => clearInterval(countCheck);
        }
    }, [loading])

    return (
        <div>
            {
                items.map((row, index) => (
                    index === 0
                        ? <button type="button"
                                  className="nv_blue_button"
                                  style={{marginRight:'5px'}}
                                  key={`menuOptionItemsKey-${index}`}
                                  onClick={() => handlerClose(row.onClickHandler)}>
                            {
                                loading ? row.innerHTML : row.innerHTML
                            }
                        </button>
                        : <button type="button"
                                  className="nv_red_button"
                                  style={{marginRight:'5px'}}
                                  key={`menuOptionItemsKey-${index}`}
                                  onClick={() => handlerClose(row.onClickHandler)}>
                            {
                                loading ? row.innerHTML : row.innerHTML
                            }
                        </button>

                ))
            }
        </div>
    )
}